var fuelDispenserList = (function () {

    const init = function () {
        $('#fuel-dispensers-datatable').DataTable({
            "autoWidth": false,
            "stateSave": true,
            "responsive": true,
            "order": [],
            "columnDefs": [
                { "className": 'fuel-dispenser-model-column', "targets": 0 },
                { "className": 'serial-number-column', "targets": 1 },
                { "className": 'api-token-column desktop', "targets": 2 },
                { "className": 'client-column', "targets": 3 },
                { "className": 'status-column desktop', "targets": 4 },
                { "className": 'date-columns desktop', "targets": [6, 5] },
                { "className": 'fuel-dispenser-actions-column desktop', "targets": 7 },
                { "orderable": false, "targets": 7 },

                { "targets": 5, "data": 'ActivatedOn' },
                { "targets": 6, "data": 'LastTimeConnected' },
                { "targets": [5, 6], "render": dataTableCommon.renderDate, "type": 'num' }
            ],
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json'
                //TODO: make it depends on current culture not on sdn call
            }
        });

        $('#fuel-dispensers-datatable')
            .on('click', '.mdi-lock', function () {
                const id = $(this).data('fuel-dispenser-id');
                sendBlockRequest(id);
            });

        $('#fuel-dispensers-datatable')
            .on('click', '.mdi-lock-open-outline', function () {
                const id = $(this).data('fuel-dispenser-id');
                sendUnblockRequest(id);
            });

        $('#fuel-dispensers-datatable')
            .on('click', '.mdi-delete', function () {
                const id = $(this).data('fuel-dispenser-id');
                const serial = $(this).data('fuel-dispenser-serial-number');
                $('#fuel-dispenser-serial-number-to-delete').text(serial);
                $('#delete-fuel-dispenser-button').attr('data-fuel-dispenser-id', id);
            });

        $('#delete-fuel-dispenser-button').on('click',
            function () {
                const fuelDispenserIdToDelete = $(this).data('fuel-dispenser-id');
                sendDeleteRequest(fuelDispenserIdToDelete);
            });

        function sendBlockRequest(id) {
            $.ajax({
                    url: `/FuelDispensers/Block/${id}`,
                    method: 'PUT',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }

        function sendUnblockRequest(id) {
            $.ajax({
                    url: `/FuelDispensers/Unblock/${id}`,
                    method: 'PUT',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }

        function sendDeleteRequest(id) {
            $.ajax({
                    url: `/FuelDispensers/Delete/${id}`,
                    method: 'DELETE',
                    contentType: 'application/json'
                })
                .done(function (data) {
                    $('#delete-modal').modal('hide');
                    $.showNotification(data.header, data.message, data.succeed);
                });
        }
    };

    return {
        init: init
    };

})();
